<script>
    import {getContext} from 'svelte';
    import Form from "./Form.svelte";
    import {form} from "../stores/store";

    const {close} = getContext('simple-modal');

    export let formTitle;
    let isLoading = false;
</script>

<h2 class="form-header">{formTitle}</h2>

<hr>
{#if form && $form.success}
    <p>Спасибо! Мы скоро с вами свяжемся.</p>
{:else}
    <Form/>
{/if}

<style>
    .form-header {
        color: var(--main-color)
    }
</style>
